import axios from "axios";
import { useEffect, useState } from "react";
import { Container, Image, Row, Col } from "react-bootstrap";
import astronaut from "../assets/Astronaut.png";
import WLT from "../assets/WLTLight.svg";

const Footer = () => {
  const [collaboratorsInfo, setCollaboratorsInfo] = useState("");
  useEffect(() => {
    getInfoCollaborators();
  }, []);
  const getInfoCollaborators = () => {
    axios
      .get(`${process.env.REACT_APP_URL_API}/institucional`)
      .then(function (response) {
        setCollaboratorsInfo(response.data?.Colaboradores?.colaboradores_anio);
      });
  };
  return (
    <Container fluid id="footerMaps">
      <Row className="footerDesktop">
        <Col lg={2}>
          <Image src={astronaut} />
        </Col>
        <Col lg={8} className="text-center">
          <h1>{collaboratorsInfo}</h1>
        </Col>        
      </Row>
      <Row className="footerMobile">
        <Col xs={6}>
          <Image src={WLT} className="logoWLT img-fluid" />
        </Col>
      </Row>
    </Container>
  );
};
export default Footer;
